module.exports = __webpack_public_path__ + "img/_calendar_small_primary.675cc40b.svg";